import { Outlet, useLocation } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { SessionExpiryWarning } from "../../features/auth/components/SessionExpiryWarning";
import { VNextScope } from "@/components/brand/vnext";
import { useSessionRestore, AuthFlowDialog } from "@/features/session";
import { useBrowserWalletStore } from "@/features/wallet";
import { usePreferencesStore } from "@/store/preferences-store";

/**
 * Main Layout Component
 * Root layout wrapper with header, navigation, and footer.
 *
 * Everything under it renders inside one `VNextScope` (spec 2026-09-06 vNext
 * page migration, D2): `vnext.css` remaps the Tailwind / MD3 tokens inside
 * `.dt-vnext`, so legacy Brand and shadcn components resolve to the vNext
 * palette without being rewritten. The theme is the person's per-device
 * preference (spec 2026-09-07 D18): `light` / `dark` stamped wins, and
 * "follow the device" passes no stamp so `prefers-color-scheme` decides.
 * Marketing pages under `PublicLayout` are untouched.
 */
export function MainLayout() {
  useSessionRestore();
  const openModal = useBrowserWalletStore((s) => s.openModal);
  const theme = usePreferencesStore((s) => s.theme);
  const { pathname } = useLocation();
  const candidate = /^\/(chat|trade|assets|pay|send|scan|receive|confirm|receipt|fleet|new-chat)(\/|$)/.test(pathname);

  return (
      <VNextScope className="dt-app-shell" theme={theme === "system" ? undefined : theme}>
        <div className="min-h-screen bg-background text-foreground flex flex-col">
          <SessionExpiryWarning onReAuthenticate={() => openModal()} />
          {!candidate && <Header />}
          <main className={candidate ? "w-full flex-grow" : "max-w-7xl mx-auto px-4 py-6 flex-grow w-full pb-24 md:pb-6"}>
            <Outlet />
          </main>
          {!candidate && <Footer />}
          <AuthFlowDialog />
        </div>
      </VNextScope>
  );
}
